export const accessTokenActionType = {
  SAVEACCESSTOKEN: "SAVEACCESSTOKEN",
};
